<template>
  <div style="width: 100%;height: 100%;">
    <div style="width: 100%;background-color: #fff;">
      <div class="headerBox">
        <div class="hearderContentBox">
          <div class="titleBox">
            <div class="logoBox">
              <img :src="getImg(webSiteInfo.logo)" alt="">
            </div>
            <span style="margin-left: 10px;">{{ platformName }}</span>
          </div>
          <div class="rightBox" v-if="user.phoneNumber">
            <a-dropdown>
              <template #overlay>
                <a-menu style="margin-top:-30px">
                  <a-menu-item key="3">
                    <a @click="onLogout()">
                      <PoweroffOutlined /> 退出登录
                    </a>
                  </a-menu-item>
                </a-menu>
              </template>
              <a class="ant-dropdown-link" style="margin-left:20px;position:relative;padding:0 10px 0 10px"
                @click="islogin">
                <img style="position:absolute; left:-9px; top:38px" src="@/assets/img/login.png" alt=""> {{
                  user.phoneNumber
                }}
              </a>
            </a-dropdown>

          </div>
          <div class="rightBox" v-else>
            <div class="loginBox">
              <img src="@/assets/img/login.png" />
              <!-- <a-dropdown> -->
              <span @click="goMore('/login', 'user')" style="margin-left: 10px;">登录</span>
              <!-- <template #overlay>
									<a-menu>
										<a-menu-item>
											<span @click="goMore('/login', 'manage')">管理员</span>
										</a-menu-item>
										<a-menu-item>
											<span @click="goMore('/login', 'user')">普通用户</span>
										</a-menu-item>
									</a-menu>
								</template> -->
              <!-- </a-dropdown> -->
            </div>
            <a-divider class="lineBox" type="vertical" />
            <div class="resigierBox" @click="this.$router.push('/register')">注册</div>
          </div>

          <div class="rightBox" style="margin-right:20px">

            <a-dropdown>
              <template #overlay>
                <a-menu style="margin-top:-30px">
                  <a-menu-item @click="goMore('/Innovation/index')" key="2">
                    创新创业
                  </a-menu-item>
                  <a-menu-item @click="goMore('/finance/index')" key="3">
                    科技金融
                  </a-menu-item>
                  <a-menu-item @click="goMore('/knowledge/index')" key="4">
                    知识产权
                  </a-menu-item>
                  <a-menu-item @click="goMore('/EducationService/index')" key="5">
                    科技人才
                  </a-menu-item>
                  <a-menu-item @click="goMore('/achievements/index')" key="6">
                    成果转化
                  </a-menu-item>
                </a-menu>
              </template>
              <a class="ant-dropdown-link" @click="goMore('/')">
                <!-- <HomeOutlined />  -->
                首页
                <DownOutlined />
              </a>
            </a-dropdown>
          </div>
        </div>
      </div>
      <!-- <div class="bannerBox">
        <a-carousel :dot-position="bottom" autoplay>
          <div class="bannerImg" v-for="(item, index) in bannerData" :key="index">
            <img :src="getImg(item.imageUrl)" />
          </div>
        </a-carousel>
      </div> -->
      <!-- <div style="width: 100%;background-color: #fff;margin-top: 1%;">
        <div class="breadBox">
          <a-breadcrumb>
            <span>
              <img src="@/assets/img/position.png" />
              当前位置：
            </span>
            <a-breadcrumb-item style="cursor: pointer;" @click="this.$router.push('/')">首页</a-breadcrumb-item>
            <a-breadcrumb-item>基地</a-breadcrumb-item>
          </a-breadcrumb>
        </div>
      </div> -->
      <div class="pointsBox">
        <a-carousel arrows autoplay="true">
          <!-- <template #prevArrow>
            <div class="custom-slick-arrow" style="left: 10px; z-index: 1">
              <left-circle-outlined />
            </div>
          </template>
          <template #nextArrow>
            <div class="custom-slick-arrow" style="right: 10px">
              <right-circle-outlined />
            </div>
          </template> -->
          <div v-for="(i, a) in corpBaseInfo" :key="a">
            <!-- <div class="pointsTitle">企业积分制</div> -->
            <div class="hearderBox">
              <div style="color: #0a2c83;">
                <div style="font-size: 20px;color: #000;">基地风采</div>
                <div style="float: left;opacity: 0.5;margin-top: -20px;">
                  <img src="@/assets/img/fontback.png" alt="">
                </div>
              </div>
            </div>
            <div class="pointsSmallBox">
              <div class="imgBox" v-for="(item, index) in i.picData" :key="index">
                <img :src="getImg(item.uid)" />
              </div>
            </div>
            <div class="hearderBox">
              <div style="color: #0a2c83;">
                <div style="font-size: 20px;color: #000;">基地简介</div>
                <div style="float: left;opacity: 0.5;margin-top: -20px;">
                  <img src="@/assets/img/fontback.png" alt="">
                </div>
              </div>
            </div>
            <div class="conBox">
              <div class="titleBox">
                {{ i.baseName }}
              </div>
              <div class="desc" style="min-height: 300px;max-height: 340px;" v-html="i.baseDescription"></div>
            </div>
            <div style="width: 100%;margin: 20px 0;background-color: #f0f2f5;">
              <div class="cardBox">
                <div class="smallCardBox">
                  <!-- <div class="leftImg">
                    <img src="@/assets/img/rzqy.png" />
                  </div> -->
                  <div class="rightText">入驻企业总数：<span style="color: #0048c4;">{{ i.companyCount }}</span> 家</div>
                </div>
                <a-divider style="top: 44px;height: 34px" type="vertical" />
                <div class="smallCardBox">
                  <!-- <div class="leftImg">
                    <img src="@/assets/img/xzqy.png" />
                  </div> -->
                  <div class="rightText">上一年总营收：<a @click="goMore('/corpBase')" style="color: #0048c4;">{{ i.baseCount
                  }}</a> 万元</div>
                </div>
                <a-divider style="top: 44px;height: 34px" type="vertical" />
                <div class="smallCardBox">
                  <!-- <div class="leftImg">
                    <img src="@/assets/img/xzqy.png" />
                  </div> -->
                  <div class="rightText">高新技术企业数量：<span style="color: #0048c4;">{{ i.intellectualPropertyCount }}</span>
                    家
                  </div>
                </div>
                <a-divider style="top: 44px;height: 34px" type="vertical" />
                <div class="smallCardBox">
                  <!-- <div class="leftImg">
                    <img src="@/assets/img/dxxl.png" />
                  </div> -->
                  <div class="rightText">科小数量：<span style="color: #0048c4;">{{ i.highTechEnterpriseCount }}</span>
                    家
                  </div>
                </div>
              </div>
            </div>
          </div>

        </a-carousel>
        <div class="pointsBox">
          <div class="hearderBox">
            <div style="color: #0a2c83;">
              <div style="font-size: 20px;color: #000;">基地分布</div>
              <div style="float: left;opacity: 0.5;margin-top: -20px;">
                <img src="@/assets/img/fontback.png" alt="">
              </div>
            </div>
          </div>
          <div id="allmap" style="margin-top: 20px;width: 100%; height: 700px;"></div>
        </div>
      </div>
    </div>
    <LayoutFooter />
  </div>
</template>

<script>
import { login_mp } from "@/api/adminService";
import { ls } from "@/utils/util";
import { file_service } from "@/api/adminService";
import { getBannerInfo, getCorpBaseInfo } from "@/api/homeService";
import { platformName } from "@/config/platformConfig";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';
import markerIcon from '@//assets/img/marker.png';

let BMap = {};
export default {
  name: "index",
  components: {
    LayoutFooter,
  },
  mixins: [],
  data() {
    return {

      scrollNoticeData: [],
      fourObj: {},
      user: {},
      getDetailNoteParam: null,
      operatingIncomeScale: null,
      platformName,
      getAuditStatus: null,
      getDateId: null,
      bannerData: [],
      webSiteInfo: {},
      corpBaseInfo: [],
      center: { lng: 113.60528, lat: 37.87302 },
    }
  },
  methods: {
    logout() {
      let self = this;

      self.$ls.clear();
      self.$store.commit('setMenuData', []);
      self.$router.replace('/');

      location.reload();
    },
    onLogout() {
      let self = this;
      self.$confirm({
        title: '确认要退出登录?',
        content: '',
        onOk() {
          self.postAction({
            url: login_mp.saveLog,
            params: { logAppCategoryEnum: "LOGOUT" }
          }).then(res => {
            console.log(res)
            self.getAction({
              url: login_mp.logout,
              params: { access_token: ls.get("token") || "" },
              isValid: false
            }).then(() => {
              self.$notification['success']({
                message: '退出成功',
                style: {
                  fontWeight: '600',
                },
              });
            })
          })


          setTimeout(() => {
            self.logout();
          }, 2000)
        },
        onCancel() {
        },
      });
    },
    goHttp(url) {
      window.open(url, '_bank')
    },
    goMore(url, str) {
      this.$router.push({ path: url, query: { id: str } })
    },
    islogin() {
      if (ls.get('token') && ls.get("refresh_token")) {
        if (ls.get("roleCode").includes('company')) {
          this.goMore('/sys/companyInfo')
        } else if (ls.get("roleCode").includes('technicalManager')) {
          this.goMore('/sys/technology/person');
        } else if (ls.get("roleCode").includes('serviceOrganization')) {
          this.goMore('/sys/innovation/organization/index');
        } else if (ls.get("roleCode").includes('investorManager')) {
          this.goMore('/finance/investorInformation');
        } else if (ls.get("roleCode").includes('investmentMechanism')) {
          this.goMore('/finance/investmentOrganizationInformation');
        } else if (ls.get("roleCode").includes('financialAdviser')) {
          this.goMore('/finance/financialAdvisorInformation');
        } else if (ls.get("roleCode").includes('bank')) {
                this.goMore('/finance/financingInstitutionInformation');
                }else {
          this.goMore('/sys/userInfo')
        }
      } else {
        this.goMore('/login', 'user')
      }
    },
    getBannerList() {
      this.getAction({
        url: getBannerInfo.pageList,
        params: { type: 'home' }
      }).then(res => {
        this.bannerData = res.records.reverse()
      })
    },
    getCorpBaseInfo() {
      this.getAction({
        url: getCorpBaseInfo.baseInfo,
        params: {}
      }).then(res => {

        console.log('res', res)
        res.map(item => {
          if(item.baseImage){
            item.picData = this.imgArr(item.baseImage)
          }else{
            item.picData = []
          }
        })
        this.corpBaseInfo = res
        console.log('res', this.corpBaseInfo)
      })
    },
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
    imgArr(str) {
      let list = str.split(',').filter(v => v)
        .map((v) => {
          return {
            uid: v,
            name: v.split('|')[1],
            status: "done",
            url: '',
          };
        });
      list.forEach(item => {
        file_service.setImgUrl(item)
      })
      return list
    },

    // 初始化百度地图
    initBaiduMap() {
      BMap = window.BMap;

      // 创建小车图标
      let myIcon = new BMap.Icon(markerIcon, new BMap.Size(52, 26))
      // 地图的相关操作
      this.$nextTick(function () {
        // let th = this;
        // 创建Map实例
        // eslint-disable-next-line no-undef
        let map = new BMap.Map("allmap");
        // 初始化地图,设置中心点坐标，
        // eslint-disable-next-line no-undef
        let point = new BMap.Point(this.center.lng, this.center.lat); // 创建点坐标，汉得公司的经纬度坐标
        map.centerAndZoom(point, 18);
        map.enableScrollWheelZoom();
        // let marker = new BMap.Marker(point, {
        //   icon: myIcon
        // });
        map.addOverlay(new BMap.Marker(point, {
          icon: myIcon
        })); //添加标注
      });
    },
  },
  mounted() {
    this.str = this.$route.query.type
    this.getBannerList()
    this.getCorpBaseInfo()
    this.initBaiduMap();
    // this.getDate()
    if (ls.get('token') && ls.get("refresh_token")) {
      this.user.userName = this.$ls.get('userName')
      this.user.phoneNumber = this.$ls.get('phoneNumber')
    }
  }
}
</script>

<style scoped lang="less">
:deep(.ant-btn) {
  color: #fc550b;
  font-weight: 600;
  padding: 0 10px;

  img {
    margin-right: 5px
  }

  &:hover {
    border-color: #ffffff;
    box-shadow: 1px 1px 5px 1px #a7a7a7;
  }
}

.headerBox {
  width: 100%;
  height: 92px;
  background-color: #fff;

  .hearderContentBox {
    width: 1200px;
    margin: 0 auto;

    .titleBox {
      cursor: pointer;
      overflow: hidden;
      float: left;
      line-height: 92px;
      font-size: 30px;
      font-weight: bold;

      .logoBox {
        float: left;
        width: 73px;
        height: 66px;
        margin-right: 5px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .rightBox {
      float: right;
      display: flex;
      justify-content: space-around;
      line-height: 92px;
      font-size: 16px;

      a {
        font-weight: 600;
      }

      .loginBox {
        // float: left;
        cursor: pointer;
      }

      .loginBox:hover {
        color: #fc550b;
      }

      .lineBox {
        height: 18px;
        top: 36px;
      }

      .resigierBox {
        cursor: pointer;
        // float: left;
      }

      .resigierBox:hover {
        color: #fc550b;
      }
    }
  }
}

.bannerBox {
  position: relative;
  width: 100%;

  :deep(.ant-carousel) {
    position: relative;
    width: 100%;
  }

  .bannerImg {
    width: 100%;
    height: 282px;

    img {
      width: 100%;
      object-fit: cover;
      height: 280px;
    }
  }
}

.breadBox {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
}

.pointsBox {
  width: 1200px;
  margin: 0 auto;
  padding: 0 0 55px 0;

  .hearderBox {
    margin: 20px 0;
  }

  .pointsSmallBox {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .imgBox {
      width: 22%;
      height: 181px;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  .conBox {
    overflow: hidden;
    width: 100%;

    .titleBox {
      font-size: 22px;
      font-weight: bold;
      color: #333;
      text-align: center;
      margin-bottom: 15px;
    }

    .desc {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
    }
  }

  .cardBox {
    display: flex;
    justify-content: space-between;
    width: 1200px;
    height: auto;
    margin: 0 auto;
    // background-color: #fff;

    .smallCardBox {
      margin: 36px auto;
      height: 46px;

      .leftImg {
        float: left;
        width: 46px;
        height: 46px;
        border-radius: 50%;
      }

      .rightText {
        float: left;
        margin-left: 5px;
        line-height: 46px;

        a,
        span {
          font-size: 24px;
          color: #0048c4;
        }
      }
    }
  }
}

.linkBig {
  width: 100%;
  background-color: #fff;

  .linkBox {
    overflow: hidden;
    font-size: 16px;
    color: #333;
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;


    .leftLabel {
      float: left;
      width: 7%;
      font-weight: bold;
    }

    .rightBox {
      float: left;
      margin-left: 15px;
      width: 90%;
      // display: flex;
      // justify-items: start;
      // flex-wrap: wrap;

      .itemLink {
        float: left;
        margin-right: 30px;
        margin-bottom: 5px;
        color: #333;
        // text-decoration: underline;
      }

      .itemLink:hover {
        color: #0a2c83;
      }
    }
  }
}

.footerBox {
  width: 100%;
  background-color: #333333;

  .footerContent {
    position: relative;
    margin: 0 auto;
    padding: 24px 0;
    width: 1200px;

    .firstLine {
      padding: 8px 0;
      font-size: 14px;
      color: #999;

      span {
        margin-right: 18px;
      }
    }

    .footCode {
      position: absolute;
      right: 0;
      bottom: 12%;
      text-align: center;

      .footEwm {
        margin-bottom: 8px;
      }

      .footEwmTitle {
        color: #999;
      }
    }
  }
}

:deep(.ant-list-lg .ant-list-item) {
  padding: 16px 8px;
}

:deep(.slick-arrow.custom-slick-arrow) {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.2);
  transition: ease all 0.3s;
  opacity: 0.3;
  z-index: 1;
}

:deep(.slick-arrow.custom-slick-arrow:before) {
  display: none;
}

:deep(.slick-arrow.custom-slick-arrow:hover) {
  color: #fff;
  opacity: 0.5;
}

:deep(.slick-slide h3) {
  color: #fff;
}
</style>
